import { Link } from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';

import Info from './Info';
import Subtitle from '../../components/Subtitle';

const WaitingListInfo = ({
  barberName,
  serviceName,
  serviceDuration,
  shopName,
  shopAddress,
  shopZip,
  shopLocation,
  numberInLine,
}) => (
  <div>
    <Subtitle>Waiting List</Subtitle>
    <Info
      barberName={barberName}
      serviceName={serviceName}
      serviceDuration={serviceDuration}
      shopName={shopName}
      shopAddress={shopAddress}
      shopZip={shopZip}
      shopLocation={shopLocation}
      numberInLine={numberInLine}
    />
    <Link to="/" className="c-btn c-btn--secondary u-mt+">
      Back to home
    </Link>
  </div>
);
WaitingListInfo.propTypes = {
  barberName: PropTypes.string.isRequired,
  serviceName: PropTypes.string.isRequired,
  serviceDuration: PropTypes.string.isRequired,
  shopName: PropTypes.string.isRequired,
  shopAddress: PropTypes.string.isRequired,
  shopZip: PropTypes.string.isRequired,
  shopLocation: PropTypes.shape({
    coordinates: PropTypes.arrayOf(PropTypes.number),
  }),
  numberInLine: PropTypes.number.isRequired,
};
WaitingListInfo.defaultProps = {
  shopLocation: null,
};

export default WaitingListInfo;



// WEBPACK FOOTER //
// ./src/app/waitingList/components/WaitingListInfo.jsx